import React, { useState } from 'react';
import { useShop } from '../../context/ShopContext';
import { 
  Globe, 
  Search, 
  Share2, 
  FileCode, 
  CheckCircle2, 
  Save, 
  ExternalLink, 
  MessageSquare, 
  ShoppingBag,
  Sparkles,
  Link2
} from 'lucide-react';

export default function AdminSEOMarketing() {
  const { storeSettings, addToast } = useShop();

  const [metaTitle, setMetaTitle] = useState('M.L. Jewellers & Kitchenware | BIS Hallmarked Gold & Pure Silver Showroom Jaipur');
  const [metaDesc, setMetaDesc] = useState('Shop 100% BIS Hallmarked 22KT gold bridal jewellery, natural diamond solitaire rings, 999 pure silver utensils, and premium kitchenware at unmasked artisan prices in Jaipur.');
  const [canonicalUrl, setCanonicalUrl] = useState('https://mljewellersandkitchenware.com');
  const [ogImageUrl, setOgImageUrl] = useState('https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&w=1200&q=80');
  const [googleMerchantActive, setGoogleMerchantActive] = useState(true);
  const [fbPixelId, setFbPixelId] = useState('PIXEL-98124912');
  const [googleAnalyticsId, setGoogleAnalyticsId] = useState('G-MLJ998123');

  const handleSaveSEO = (e) => {
    e.preventDefault();
    addToast?.('SEO Meta Tags, Open Graph & Tracking Pixels updated successfully', 'success');
  };

  return (
    <div style={{ maxWidth: '1240px', margin: '0 auto' }}>
      
      {/* Top Banner */}
      <div style={{
        background: '#ffffff',
        borderRadius: '8px',
        padding: '1.25rem 1.6rem',
        border: '1px solid #e0e0e0',
        marginBottom: '1.5rem',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
      }}>
        <div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', color: '#2874f0', fontSize: '0.72rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '0.2rem' }}>
            <Globe size={14} />
            <span>ORGANIC DISCOVERY & CONVERSION TRACKING</span>
          </div>
          <h2 style={{ fontSize: '1.45rem', fontWeight: 800, color: '#212121', margin: 0 }}>
            SEO Engine & Marketing Integrations
          </h2>
          <p style={{ margin: '0.2rem 0 0', fontSize: '0.82rem', color: '#616161' }}>
            Google Search Console meta tags, OpenGraph luxury preview cards, XML Sitemap & Google Merchant Feed.
          </p>
        </div>

        <button
          onClick={handleSaveSEO}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            padding: '0.55rem 1.1rem',
            borderRadius: '4px',
            border: 'none',
            background: '#2874f0',
            color: '#ffffff',
            fontWeight: 700,
            fontSize: '0.82rem',
            cursor: 'pointer'
          }}
        >
          <Save size={15} />
          <span>Save Changes</span>
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: '1.5rem', alignItems: 'start' }}>
        
        {/* Left: Meta Fields */}
        <form onSubmit={handleSaveSEO} style={{ background: '#ffffff', borderRadius: '8px', padding: '1.4rem', border: '1px solid #e0e0e0' }}>
          <h3 style={{ fontSize: '1.05rem', fontWeight: 800, color: '#1e293b', margin: '0 0 1.2rem', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <Search size={17} color="#2874f0" />
            <span>Search Engine Optimization (SEO) Metadata</span>
          </h3>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#475569' }}>Global SEO Title Tag *</label>
                <span style={{ fontSize: '0.7rem', color: metaTitle.length > 60 ? '#d97706' : '#15803d', fontWeight: 700 }}>
                  {metaTitle.length}/60 characters (Optimal)
                </span>
              </div>
              <input
                type="text"
                value={metaTitle}
                onChange={(e) => setMetaTitle(e.target.value)}
                style={{ width: '100%', padding: '0.6rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem' }}
              />
            </div>

            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#475569' }}>Meta Description *</label>
                <span style={{ fontSize: '0.7rem', color: metaDesc.length > 160 ? '#d97706' : '#15803d', fontWeight: 700 }}>
                  {metaDesc.length}/160 characters
                </span>
              </div>
              <textarea
                rows={3}
                value={metaDesc}
                onChange={(e) => setMetaDesc(e.target.value)}
                style={{ width: '100%', padding: '0.6rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem', resize: 'vertical' }}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.8rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#475569', marginBottom: '0.3rem' }}>Canonical Domain URL</label>
                <input
                  type="text"
                  value={canonicalUrl}
                  onChange={(e) => setCanonicalUrl(e.target.value)}
                  style={{ width: '100%', padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#475569', marginBottom: '0.3rem' }}>Google Analytics 4 ID</label>
                <input
                  type="text"
                  value={googleAnalyticsId}
                  onChange={(e) => setGoogleAnalyticsId(e.target.value)}
                  style={{ width: '100%', padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem' }}
                />
              </div>
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#475569', marginBottom: '0.3rem' }}>Open Graph Social Share Banner URL</label>
              <input
                type="text"
                value={ogImageUrl}
                onChange={(e) => setOgImageUrl(e.target.value)}
                style={{ width: '100%', padding: '0.55rem', border: '1px solid #cbd5e1', borderRadius: '4px', fontSize: '0.85rem' }}
              />
            </div>

            <div style={{ background: '#f8fafc', padding: '0.9rem', borderRadius: '6px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <div style={{ fontSize: '0.75rem', fontWeight: 800, color: '#1e293b' }}>Automated Feed Endpoints:</div>
              <div style={{ fontSize: '0.78rem', color: '#2563eb', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                <Link2 size={13} />
                <span>XML Sitemap: <code>https://mljewellersandkitchenware.com/sitemap.xml</code></span>
              </div>
              <div style={{ fontSize: '0.78rem', color: '#2563eb', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                <Link2 size={13} />
                <span>Google Merchant Product Feed: <code>https://mljewellersandkitchenware.com/api/merchant_feed.xml</code></span>
              </div>
            </div>
          </div>
        </form>

        {/* Right: Google SERP Live Simulation */}
        <div>
          <div style={{ background: '#ffffff', borderRadius: '8px', padding: '1.4rem', border: '1px solid #e0e0e0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
            <h4 style={{ fontSize: '0.78rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', margin: '0 0 1rem' }}>
              Live Google Search Preview
            </h4>

            <div style={{ background: '#ffffff', border: '1px solid #dadce0', borderRadius: '8px', padding: '1.2rem', fontFamily: 'Arial, sans-serif' }}>
              <div style={{ fontSize: '0.8rem', color: '#202124', display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.2rem' }}>
                <span style={{ width: '18px', height: '18px', borderRadius: '50%', background: '#2874f0', color: '#fff', fontSize: '0.65rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800 }}>ML</span>
                <span style={{ fontSize: '0.8rem', color: '#202124' }}>mljewellersandkitchenware.com</span>
              </div>
              <div style={{ color: '#1a0dab', fontSize: '1.15rem', fontWeight: 500, lineHeight: '1.3', cursor: 'pointer', marginBottom: '0.3rem' }}>
                {metaTitle}
              </div>
              <div style={{ color: '#4d5156', fontSize: '0.82rem', lineHeight: '1.4' }}>
                {metaDesc}
              </div>
            </div>

            {/* Social Share Card Preview */}
            <h4 style={{ fontSize: '0.78rem', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', margin: '1.5rem 0 0.8rem' }}>
              WhatsApp & Facebook Share Preview
            </h4>
            <div style={{ border: '1px solid #e2e8f0', borderRadius: '6px', overflow: 'hidden', background: '#f8fafc' }}>
              <img
                src={ogImageUrl}
                alt="Social Preview"
                style={{ width: '100%', height: '140px', objectFit: 'cover' }}
              />
              <div style={{ padding: '0.8rem' }}>
                <div style={{ fontSize: '0.68rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 700 }}>MLJEWELLERSANDKITCHENWARE.COM</div>
                <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1e293b', margin: '0.2rem 0' }}>{metaTitle}</div>
                <div style={{ fontSize: '0.75rem', color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{metaDesc}</div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
}
